import React, { Component } from 'react';
import { Row, Modal, Form, Input, TimePicker, DatePicker, Select, Button, Tag, Icon, message, Tooltip } from "antd";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from "moment";
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axios from "axios";
import "./Pages.css";
import Colors from '../utils/Colors';
import { getTemPermissao } from "../utils/LoginManager";
import Agenda from '../tutoriais/Agenda';

import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';


const DnDCalendar = withDragAndDrop(Calendar);

moment.locale('pt-br');
const localizer = momentLocalizer(moment);
const { Option } = Select;

const statusCores = {
    0: { label: 'Pendente', color: '#2f94f4' },    // Azul
    1: { label: 'Em Andamento', color: '#d8a235' }, // Amarelo/Laranja
    2: { label: 'Concluído', color: '#67bd3c' },    // Verde
    3: { label: 'Cancelado', color: '#d3323a' },    // Vermelho
};

export default class AgendaPage extends Component {
    state = {
        eventos: [],
        tiposAgendas: [],
        age_descricao: '',
        age_idf: null,
        age_situacao: 0,
        tecnicosSelecionados: [],
        isModalVisible: false,
        selectedSlot: null,

        currentView: 'day',
        currentDate: moment().startOf('day').toDate(),
    };


    componentDidMount() {
        this.onBuscaTiposAgendas();
        const hoje = new Date();
        this.getListaRegistros(moment(hoje).startOf('day'), moment(hoje).endOf('day'));
    }



    getListaRegistros = (start, end) => {
        this.setState({ carregando: true });

        // Formata as datas para enviar ao banco (Ex: YYYY-MM-DD)
        const dataInicio = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const dataFim = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');

        axios.get('/agenda/lista', {
            params: { dataInicio, dataFim }
        })
            .then(response => {
                const eventos = response.data.map(reg => ({
                    id: reg.age_idf,
                    title: reg.age_descricao,
                    start: new Date(reg.age_datahora_ini),
                    end: new Date(reg.age_datahora_fim),
                    resourceId: reg.age_tipo,
                    situacao: reg.age_situacao
                }));
                this.setState({ eventos, carregando: false });
            })
            .catch(() => this.setState({ carregando: false }));
    };


    onBuscaTiposAgendas = () => {
        this.setState({ tiposAgendas: [] })
        axios.get('/tipoAgenda/lista')
            .then(response => {
                const { data } = response;
                const tiposAgendas = data.map(regList => {
                    return {
                        id: regList.ta_idf,
                        title: regList.ta_descricao,
                        color: regList.ta_cor,
                    }
                });
                this.setState({
                    tiposAgendas,
                })
            }).catch(error => {
                console.error(error.response);
            })
    };

    handleRangeChange = (range) => {
        // O 'range' pode vir como um Array [start, end] ou um Objeto { start, end }
        // dependendo da visualização (Mês/Semana vs Dia)
        let start, end;

        if (Array.isArray(range)) {
            start = range[0];
            end = range[range.length - 1];
        } else {
            start = range.start;
            end = range.end;
        }

        this.getListaRegistros(start, end);
    };

    // Abre modal ao clicar em um espaço vazio
    handleSelectSlot = (slotInfo) => {
        this.setState({
            isModalVisible: true,
            age_idf: null,
            age_descricao: '',
            selectedSlot: { ...slotInfo }
        });
    };

    // Abre modal ao clicar em um evento existente
    handleSelectEvent = (event) => {
        this.setState({
            isModalVisible: true,
            age_idf: event.id,
            age_descricao: event.title,
            age_situacao: event.situacao,
            selectedSlot: {
                start: event.start,
                end: event.end,
                resourceId: event.resourceId
            }
        });
    };


    eventStyleGetter = (event) => {
        // Busca a cor no objeto statusCores definido lá no topo do arquivo
        // Se não encontrar a situação (ex: undefined), usa o azul padrão
        const status = statusCores[event.situacao] || { color: '#3174ad' };

        return {
            style: {
                backgroundColor: status.color,
                borderRadius: '4px',
                opacity: 0.85,
                color: 'white',
                border: 'none',
                display: 'block',
                fontSize: '12px',
                fontWeight: '500',
                textDecoration: event.situacao === 3 ? 'line-through' : 'none',
            }
        };
    };


    // 1. Função para definir o estilo do fundo (slots)
    handleSlotProp = (date, resourceId) => {
        // Busca o técnico para pegar a cor definida no array
        const tecnico = this.state.tiposAgendas.find(t => t.id === resourceId);

        if (tecnico) {
            return {
                style: {
                    // Usamos uma cor bem clara (rgba) para não atrapalhar a leitura
                    backgroundColor: tecnico.color + '90',
                    // backgroundColor: tecnico.color,
                    borderRight: '1px solid #f0f0f0'
                }
            };
        }
        return {};
    };


    // Adicione este componente customizado
    EventoCustomizado = ({ event }) => (
        <span style={{ fontSize: 18 }}>
            {/* {event.situacao && <Icon type="check-circle" style={{ marginRight: 10 }} />} */}
            <strong>{event.title}</strong>
        </span>
    );

    formatos = {
        timeGutterFormat: 'HH:mm',
        eventTimeRangeFormat: ({ start, end }, culture, localizer) =>
            localizer.format(start, 'HH:mm', culture) + ' - ' + localizer.format(end, 'HH:mm', culture),
        dayHeaderFormat: 'dddd, DD [de] MMMM',
    };


    AgendaEventCustom = ({ event }) => {
        const tecnico = this.state.tiposAgendas.find(t => t.id === event.resourceId);

        return (
            <div style={{
                borderLeft: `5px solid ${tecnico ? tecnico.color : '#ccc'}`,
                paddingLeft: '10px',
                margin: '2px 0'
            }}>
                <b style={{ color: tecnico ? tecnico.color : '#333', fontSize: '12px' }}>
                    {tecnico ? tecnico.title.toUpperCase() : 'SEM TÉCNICO'}
                </b>
                <div style={{ fontSize: '14px' }}>
                    {event.title}
                    <span style={{ marginLeft: '10px', opacity: 0.6 }}>
                        ({statusCores[event.situacao].label})
                    </span>
                </div>
            </div>
        );
    };

    toggleFiltroTecnico = (tecnicoId) => {
        const { tecnicosSelecionados } = this.state;
        let novosSelecionados;

        if (tecnicosSelecionados.includes(tecnicoId)) {
            // Se já estiver selecionado, remove do filtro
            novosSelecionados = tecnicosSelecionados.filter(id => id !== tecnicoId);
        } else {
            // Se não estiver, adiciona ao filtro
            novosSelecionados = [...tecnicosSelecionados, tecnicoId];
        }

        this.setState({ tecnicosSelecionados: novosSelecionados });
    };


    handleNavigate = (date) => {
        const { currentView } = this.state;

        this.setState({
            currentDate: currentView === 'agenda'
                ? moment(date).startOf('day').toDate()
                : date
        });
    };

    handleViewChange = (view) => {
        this.setState(prevState => ({
            currentView: view,
            currentDate: view === 'agenda'
                ? moment(prevState.currentDate).startOf('day').toDate()
                : prevState.currentDate
        }));
    };




    salvarNovoEvento = () => {
        const { selectedSlot, age_idf, age_descricao, age_situacao } = this.state;

        if (!age_descricao) return alert("Digite a descrição!");

        if (moment(selectedSlot.end).isBefore(moment(selectedSlot.start))) {
            return alert("A data de término não pode ser anterior ao início!");
        }

        const eventoConflitante = this.verificarConflito();
        if (eventoConflitante) {
            return Modal.error({
                title: 'Conflito de Agenda',
                content: `Este técnico já possui o evento "${eventoConflitante.title}" agendado para este horário.`
            });
        }

        const registro = {
            age_datahora_ini: moment(selectedSlot.start).format('YYYY-MM-DD HH:mm:ss'),
            age_datahora_fim: moment(selectedSlot.end).format('YYYY-MM-DD HH:mm:ss'),
            age_tipo: selectedSlot.resourceId,
            age_descricao: age_descricao,
            age_situacao: age_situacao
        };

        this.setState({ salvando: true });

        const url = age_idf ? `/agenda/update/${age_idf}` : `/agenda/store`;
        const metodo = age_idf ? 'put' : 'post';

        axios[metodo](url, registro)
            .then(response => {
                message.success(age_idf ? 'Evento atualizado!' : 'Evento criado!');

                // Recarrega a lista para refletir as mudanças no calendário
                this.getListaRegistros(selectedSlot.start, selectedSlot.end);

                // Limpa o estado e fecha o modal
                this.setState({
                    isModalVisible: false,
                    salvando: false,
                    age_idf: null // Reseta o ID para o próximo não ser edição
                });
            })
            .catch(error => {
                this.setState({ salvando: false });
                Modal.error({ title: 'Erro ao salvar', content: error.response && error.response.data || 'Erro interno' });
            });
    };


    excluirEvento = () => {
        const { age_idf, selectedSlot } = this.state;

        Modal.confirm({
            title: 'Tem certeza que deseja excluir este evento?',
            content: 'Esta ação não poderá ser desfeita.',
            okText: 'Sim, excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: () => {
                this.setState({ salvando: true });
                axios.delete(`/agenda/delete/${age_idf}`)
                    .then(() => {
                        message.success('Evento excluído com sucesso!');
                        // Recarrega os dados do período atual
                        this.getListaRegistros(selectedSlot.start, selectedSlot.end);
                        this.setState({ isModalVisible: false, salvando: false, age_idf: null });
                    })
                    .catch(error => {
                        this.setState({ salvando: false });
                        console.error(error);
                        message.error('Erro ao excluir evento');
                    });
            }
        });
    };

    moveEvento = ({ event, start, end, resourceId }) => {
        const { eventos } = this.state;

        // Validação de Conflito para o novo local
        const novoInicio = moment(start);
        const novoFim = moment(end);

        const conflito = eventos.find(ev => {
            // Ignora o próprio evento que está sendo movido
            if (ev.id === event.id) return false;

            if (ev.resourceId === resourceId) {
                const evInicio = moment(ev.start);
                const evFim = moment(ev.end);
                // Regra de sobreposição
                return novoInicio.isBefore(evFim) && novoFim.isAfter(evInicio);
            }
            return false;
        });

        if (conflito) {
            message.warning(`Conflito: ${conflito.title} já ocupa este horário.`);
            return; // O card voltará automaticamente para a posição original
        }

        // Se não houver conflito, atualiza o estado local (UX rápida)
        const proximosEventos = eventos.map(ev => {
            return ev.id === event.id ? { ...ev, start, end, resourceId } : ev;
        });
        this.setState({ eventos: proximosEventos });

        // Persiste no Banco de Dados
        const registro = {
            age_datahora_ini: novoInicio.format('YYYY-MM-DD HH:mm:ss'),
            age_datahora_fim: novoFim.format('YYYY-MM-DD HH:mm:ss'),
            age_tipo: resourceId,
            age_descricao: event.title,
            age_situacao: event.situacao
        };

        axios.put(`/agenda/update/${event.id}`, registro)
            .then(() => {
                message.success('Agenda atualizada!');
            })
            .catch(error => {
                message.error('Erro ao salvar alteração.');
                // Em caso de erro no servidor, recarrega a lista original
                this.getListaRegistros(start, end);
            });
    };


    verificarConflito = () => {
        const { eventos, selectedSlot, age_idf } = this.state;
        const novoInicio = moment(selectedSlot.start);
        const novoFim = moment(selectedSlot.end);
        const recursoId = selectedSlot.resourceId;

        // Procura por eventos do MESMO técnico que se sobreponham ao horário atual
        const conflito = eventos.find(ev => {
            // Ignora o próprio evento se for uma edição
            if (age_idf && ev.id === age_idf) return false;

            if (ev.resourceId === recursoId) {
                const evInicio = moment(ev.start);
                const evFim = moment(ev.end);

                // Lógica de sobreposição: (Início1 < Fim2) E (Fim1 > Início2)
                return novoInicio.isBefore(evFim) && novoFim.isAfter(evInicio);
            }
            return false;
        });

        return conflito;
    };


    gerarRelatorioPDF = () => {
        // Opcional: Se quiser mudar o título da aba antes de imprimir (sai no topo do PDF)
        const tituloOriginal = document.title;
        document.title = `Relatorio_Agenda_${moment().format('DD_MM_YYYY')}`;

        window.print();

        // Volta o título original
        document.title = tituloOriginal;
    };


    gerarRelatorioExcel = () => {
        const { eventos, tiposAgendas } = this.state;

        // 1. Criar o cabeçalho da tabela HTML (que o Excel entende)
        let tabelaHtml = `
        <meta charset="UTF-8">
        <table border="1">
            <tr style="background-color: #1890ff; color: white; font-weight: bold;">
                <th>Data</th>
                <th>Início</th>
                <th>Fim</th>
                <th>Tipo Agenda</th>
                <th>Descrição</th>
                <th>Situação</th>
            </tr>
    `;

        // 2. Adicionar as linhas com os dados
        eventos.forEach(ev => {
            const tecnico = tiposAgendas.find(t => t.id === ev.resourceId).title || "N/A";
            const status = statusCores[ev.situacao].label || "Pendente";

            tabelaHtml += `
            <tr>
                <td>${moment(ev.start).format('DD/MM/YYYY')}</td>
                <td>${moment(ev.start).format('HH:mm')}</td>
                <td>${moment(ev.end).format('HH:mm')}</td>
                <td>${tecnico}</td>
                <td>${ev.title}</td>
                <td>${status}</td>
            </tr>
        `;
        });

        tabelaHtml += `</table>`;

        // 3. Criar o Blob e fazer o download (Nativo do Navegador)
        const blob = new Blob([tabelaHtml], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `agenda_${moment().format('YYYYMMDD')}.xls`;
        a.click();
        window.URL.revokeObjectURL(url);
    };


    render() {
        const { eventos, tiposAgendas, tecnicosSelecionados } = this.state;

        const tecnicosFiltrados = tecnicosSelecionados.length > 0
            ? tiposAgendas.filter(t => tecnicosSelecionados.includes(t.id))
            : tiposAgendas;

        const eventosFiltrados = tecnicosSelecionados.length > 0
            ? eventos.filter(e => tecnicosSelecionados.includes(e.resourceId))
            : eventos;


        // console.log('this.state', this.state)

        return (
            <div className="contentRoutesContainer" style={{
                padding: '20px', // Um pouco de padding ajuda no zoom
                background: '#f0f2f5',
                minHeight: '80vh', // Garante que cubra a tela toda
                height: 'auto',     // Permite que cresça além da tela se houver scroll
                overflow: 'auto'    // Evita que o conteúdo "escape"
            }}>
                <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>

                        <span className="tituloPage">Agenda</span>
                        <div className="divider-form" />
                        <br />
                        <div className="status-legenda-container" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <div>
                                <Button
                                    icon="file-excel"
                                    type="primary"
                                    onClick={this.gerarRelatorioExcel}
                                    className="botao-ajuda"
                                    style={{ width: 200 }}
                                >
                                    Exportar Excel
                                </Button>
                                <Tooltip title="Ajuda">
                                    <Button
                                        type="primary"
                                        onClick={() => this.setState({ modalOpen: true })}
                                        icon="question"
                                        className="botao-ajuda"
                                    ></Button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>



                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '15px',
                            padding: '10px',
                            background: '#f2f2f2',
                            borderRadius: '4px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Status:</span>
                                {Object.keys(statusCores).map(key => (
                                    <div key={key} style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{
                                            width: '12px',
                                            height: '12px',
                                            backgroundColor: statusCores[key].color,
                                            borderRadius: '50%',
                                            marginRight: '6px'
                                        }} />
                                        <span style={{ fontSize: '12px' }}>{statusCores[key].label}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Mantendo os Técnicos também visíveis como você já tinha */}
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Tipos Agendas:</span>
                                {this.state.tiposAgendas.map(t => {
                                    const isSelected = this.state.tecnicosSelecionados.includes(t.id);
                                    const mostrarTodos = this.state.tecnicosSelecionados.length === 0;

                                    return (
                                        <Tag
                                            key={t.id}
                                            color={isSelected || mostrarTodos ? t.color : '#f0f0f0'} // Fica cinza se não estiver selecionado
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '15px',
                                                color: Colors.primaryDark,
                                                // padding: '4px 10px',
                                                opacity: isSelected || mostrarTodos ? 1 : 0.4, // Diminui opacidade dos não filtrados
                                                border: isSelected ? `2px solid #333` : `1px solid ${t.color}`,
                                                transition: 'all 0.3s'
                                            }}
                                            onClick={() => this.toggleFiltroTecnico(t.id)}
                                        >
                                            {t.title}
                                            {isSelected && <Icon type="check" style={{ marginLeft: 5 }} />}
                                        </Tag>
                                    );
                                })}

                                {/* Botão para limpar o filtro rápido */}
                                {this.state.tecnicosSelecionados.length > 0 && (
                                    <Button
                                        size="small"
                                        type="link"
                                        onClick={() => this.setState({ tecnicosSelecionados: [] })}
                                        style={{ fontSize: '12px' }}
                                    >
                                        Limpar Filtros
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div style={{ minHeight: '600px', height: 'auto' }}>
                            <DnDCalendar
                                localizer={localizer}
                                resources={tecnicosFiltrados}
                                events={eventosFiltrados}
                                // events={this.state.eventos}
                                // resources={this.state.tiposAgendas}

                                view={this.state.currentView}
                                date={this.state.currentDate}
                                onView={this.handleViewChange}
                                onNavigate={this.handleNavigate}

                                length={1}

                                // Funções de Drag and Drop
                                onEventDrop={this.moveEvento} // Movimentação total
                                onEventResize={this.moveEvento} // Redimensionar (esticar o card)
                                resizable // Habilita esticar o card para mudar a duração
                                draggableAccessor={() => true} // Permite arrastar todos os cards

                                slotPropGetter={this.handleSlotProp}
                                resourceIdAccessor="id"
                                resourceTitleAccessor="title"
                                startAccessor="start"
                                endAccessor="end"
                                defaultView="day" // Melhor visão para múltiplos técnicos
                                views={['day', 'week', 'month', 'agenda']}
                                selectable={true}
                                onSelectSlot={this.handleSelectSlot}
                                onSelectEvent={this.handleSelectEvent}
                                eventPropGetter={this.eventStyleGetter}

                                allDayMaxRows={0}      // Define que não haverá linhas para eventos de dia inteiro
                                showAllDayAccessory={false}

                                onRangeChange={this.handleRangeChange}
                                culture="pt-BR"
                                formats={this.formatos}
                                components={{
                                    event: this.EventoCustomizado,
                                    agenda: {
                                        event: this.AgendaEventCustom // Nova customização para a lista da Agenda
                                    }
                                }}

                                step={30}           // Intervalos de 30 min ajudam a "encaixar" melhor
                                timeslots={2}       // Divide a hora em 2 slots

                                // Opcional: Definir o horário de início e fim da agenda (ex: 08:00 às 20:00)
                                min={new Date(0, 0, 0, 7, 0, 0)}
                                max={new Date(0, 0, 0, 20, 0, 0)}

                                messages={{
                                    next: "Próximo",
                                    previous: "Anterior",
                                    today: "Hoje",
                                    month: "Mês",
                                    week: "Semana",
                                    day: "Dia",
                                    agenda: "Lista Agenda",
                                    allDay: "Dia inteiro",
                                    date: "Data",
                                    time: "Hora",
                                    event: "Evento",
                                    noEventsInRange: "Não há eventos neste período.",
                                }}
                            />
                        </div>
                    </div>
                </div>



                <Modal
                    title={this.state.age_idf ? "Editar Evento" : "Novo Evento"}
                    visible={this.state.isModalVisible}
                    onCancel={() => this.setState({ isModalVisible: false, age_idf: null, age_descricao: '' })}
                    footer={[
                        this.state.age_idf && getTemPermissao('AgendaPage', 'excluir') && (
                            <Button key="delete" type="danger" style={{ float: 'left', marginLeft: 10 }} onClick={this.excluirEvento}>
                                Excluir
                            </Button>
                        ),
                        <Button key="back" onClick={() => this.setState({ isModalVisible: false, age_idf: null, age_descricao: '' })}>
                            Cancelar
                        </Button>,
                        ((!this.state.age_idf && getTemPermissao('AgendaPage', 'novo')) || (this.state.age_idf && getTemPermissao('AgendaPage', 'editar'))) && (
                            <Button key="submit" type="primary" style={{ marginRight: 10 }} loading={this.state.salvando} onClick={this.salvarNovoEvento}>
                                Salvar
                            </Button>
                        ),
                    ]}
                >
                    <Form layout="vertical">

                        <Row gutter={16}>
                            <div style={{ display: 'flex', gap: '10px', padding: '0 8px' }}>
                                <Form.Item label="Início" style={{ flex: 1 }}>
                                    <DatePicker
                                        showTime
                                        format="DD/MM/YYYY HH:mm"
                                        value={this.state.selectedSlot ? moment(this.state.selectedSlot.start) : null}
                                        onChange={(date) => this.setState({
                                            selectedSlot: { ...this.state.selectedSlot, start: date.toDate() }
                                        })}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                                <Form.Item label="Fim" style={{ flex: 1 }}>
                                    <DatePicker
                                        showTime
                                        format="DD/MM/YYYY HH:mm"
                                        value={this.state.selectedSlot ? moment(this.state.selectedSlot.end) : null}
                                        onChange={(date) => this.setState({
                                            selectedSlot: { ...this.state.selectedSlot, end: date.toDate() }
                                        })}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </div>
                        </Row>

                        <Form.Item label="Descrição do Evento">
                            <Input
                                placeholder="Descrição"
                                value={this.state.age_descricao}
                                onChange={(e) => this.setState({ age_descricao: e.target.value })}
                            />
                        </Form.Item>

                        <Form.Item label="Situação / Status">
                            <Select
                                value={this.state.age_situacao}
                                onChange={(value) => this.setState({ age_situacao: value })}
                            >
                                {Object.keys(statusCores).map(key => (
                                    <Option key={key} value={parseInt(key)}>
                                        {statusCores[key].label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>


                    </Form>
                </Modal>


                <Agenda
                    isOpen={this.state.modalOpen}
                    onClose={() => this.setState({ modalOpen: false })}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/AgendaPage.js